import { forwardRef } from 'react';
import Divider from '@segment/matcha/components/Divider';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Heading.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var HeadingBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var Icon = _ref.icon,
      children = _ref.children,
      tokens = _ref.tokens;
  return _jsxs(views.Wrapper, {
    children: [_jsxs(views.Inner, {
      children: [Icon && _jsx(Icon, {}), _jsx(views.Heading, {
        variant: "h5",
        ref: ref,
        color: tokens.color,
        children: children
      })]
    }), _jsx(Divider, {})]
  });
});
var Heading = withDesignTokens(HeadingBase, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
export default Heading;